const DoubleChevron = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
    <path
      fill="#222"
      d="M.896 10.646a.5.5 0 1 0 .708.707l4.75-4.75a.5.5 0 0 0 0-.707l-4.75-4.75a.5.5 0 1 0-.708.708L5.293 6.25.896 10.646Zm4.75 0a.5.5 0 1 0 .707.707l4.75-4.75a.5.5 0 0 0 0-.707l-4.75-4.75a.5.5 0 1 0-.707.708l4.397 4.396-4.397 4.396Z"
    />
  </svg>
);
export default DoubleChevron;
